import { isRowAveragesUid } from '@aytm/app/insights/dashboard/lib/config'
import { subjectUidsToWaveUids } from '@aytm/app/insights/dashboard/lib/uids'
import type { DataItem, SubjectType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import type { ComponentStoreState } from '../../../stores/ComponentStoreState'

function getShowingWaveCount(
  subjects: null | Record<string, SubjectType>,
  data: Record<string, string | DataItem>,
  hiddenItems: null | Array<string>
): number {
  const uids = Object.keys(data || {}).filter(uid => !isRowAveragesUid(uid) && !hiddenItems?.includes(uid)) || []
  const waveUids = subjectUidsToWaveUids(uids, subjects)
  return waveUids.size
}

export function divideByCurrentSplitCount(
  divisible: number,
  currentSplit: null | string,
  splitOptions: ComponentStoreState['splitOptions'] | null,
  swapped: boolean = false
): number {
  if (!currentSplit || !splitOptions || 0 === splitOptions.length) {
    return divisible
  }
  if (swapped) {
    return divisible
  }
  return divisible
  // return Math.floor(divisible / splitOptions.length)
}

export function calculateRespondentsRatio(
  isDynamicColumns: boolean,
  store: Partial<ComponentStoreState>
): Record<'selectedRespondents' | 'totalRespondents', number> {
  const defaultResult = {
    selectedRespondents: store?.selectedRespondents || 0,
    totalRespondents: store?.totalRespondents || 0
  }
  if (!isDynamicColumns || !store) {
    return defaultResult
  }
  const { hiddenItems, data } = store
  const negativeSum = Math.min(
    defaultResult.selectedRespondents,
    hiddenItems.reduce((subtract, uid) => {
      const subject = data[uid]
      if (!subject || 'string' === typeof subject) {
        return subtract
      }
      return subtract + (subject?.respondents || 0)
    }, 0)
  )
  return {
    ...defaultResult,
    selectedRespondents: defaultResult.selectedRespondents - negativeSum
  }
}

export function calculateSubjectsRatio(
  isDynamicColumns: boolean,
  store: Partial<ComponentStoreState>,
  currentSplit: null | string,
  swapped: boolean = false
): Record<'totalSubjects' | 'selectedSubjects', number> {
  const defaultResult = {
    totalSubjects: store?.totalSubjects || 0,
    selectedSubjects: store?.selectedSubjects || 0
  }

  if (!isDynamicColumns) {
    return defaultResult
  }

  const isPureSplitModeOn = Boolean(currentSplit) && Boolean(store.splitOptions) && !swapped
  const isSwappedSplitModeOn = Boolean(currentSplit) && Boolean(store.splitOptions) && Boolean(swapped)

  if (!store.data) {
    return defaultResult
  }
  if (isPureSplitModeOn) {
    const selectedSubjects = store.splitOptions
      ? getShowingWaveCount(store.subjects, store.data, store.hiddenItems)
      : defaultResult.selectedSubjects
    return {
      ...defaultResult,
      selectedSubjects
    }
  } else if (isSwappedSplitModeOn) {
    const selectedSubjects = store.splitOptions
      ? getShowingWaveCount(store.subjects, store.data, store.hiddenItems)
      : defaultResult.selectedSubjects
    return { ...defaultResult, selectedSubjects }
  } else {
    const selectedSubjects = getShowingWaveCount(store.subjects, store.data, store.hiddenItems)
    return {
      ...defaultResult,
      selectedSubjects
    }
  }
}
